module.exports = __webpack_public_path__ + "img/user_bg_works.416841fe.png";